'use client'

type MarketplaceSearchButtonProps = {
  onClick: () => void
  landingPage?: boolean
  headerOpacity?: number
}

export const MarketplaceSearchButton = ({
  onClick,
  landingPage = false,
  headerOpacity,
}: MarketplaceSearchButtonProps) => {
  const whiteIconOpacity =
    landingPage && headerOpacity !== undefined ? 1 - headerOpacity : 0
  const purpleIconOpacity = landingPage && headerOpacity !== undefined ? headerOpacity : 1

  const searchIcon = (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <circle
        cx="11"
        cy="11"
        r="7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21l-4.35-4.35"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  return (
    <div className="relative h-[42px] w-[42px]">
      <button
        type="button"
        onClick={onClick}
        className="absolute inset-0 w-full h-full rounded-xl border border-white/45 flex justify-center items-center text-white transition-opacity duration-300"
        style={{ opacity: whiteIconOpacity }}
        aria-label="Open search"
      >
        {searchIcon}
      </button>
      <button
        type="button"
        onClick={onClick}
        className="absolute inset-0 w-full h-full rounded-xl border border-cw-purple-lighter flex justify-center items-center text-cw-midnight-purple transition-opacity duration-300 hover:border-cw-purple-lighter-hov"
        style={{ opacity: purpleIconOpacity }}
        aria-label="Open search"
      >
        {searchIcon}
      </button>
    </div>
  )
}
